<template>
  <v-container>          
    <h1>{{ $t('order-card.c.start')}}</h1>      
    <p> {{ $t('order-card.c-start-info') }} </p>
    
    <v-form ref="form" lazy-validation class="mt-n2">
      <v-select
        v-if="apprentices.length > 0"
        v-model="personId"
        :items="apprentices"
        :label="$t('ebook.c-list-title')"
        :rules="[rules.required]"
        item-text="text"
        item-value="personId"
        append-icon="$sl-arrow-down"
        outlined
      ></v-select>
      <p v-if="apprentices.length == 0">
        Du kan inte beställa kort till några medarbetare eftersom inga medarbetare verkar ha de bevis eller behörigheter för vilka det går att beställa tryckta kort.
      </p>
    </v-form>

    <p class="overline small mt-8" v-if="educations && educations.length > 0">
      {{ $t('order-card.c-can-do') }}
    </p>
    <!-- <p class="overline small mt-8" v-if="!isCompanyOrder && educations && educations.length > 0">
      {{ $t('order-card.can-do') }}
    </p> -->

    <ActionButton v-if="showMachineBtn" @click="goTo('machine-card')" class="mt-n2" actionIcon="$sl-equipment-truck">{{
      $t('order-card.machine-card')
    }}</ActionButton>

    <ActionButton v-if="!showMachineBtn && hasTradeCertificates" @click="goTo('tradecertificate-card')" class="mt-n2" actionIcon="$sl-equipment-truck">
      {{ $t('order-card.btn-tradecertificate-card') }}
    </ActionButton>

    <!-- if can not order show error -->
    <p v-if="!showMachineBtn && educations && educations.length > 0 && !hasTradeCertificates" class="mt-3 font-italic">
      {{ $t('order-card.no-prof-text', {name: fullName}) }}
    </p>
    <!-- <p v-if="!isCompanyOrder && !showMachineBtn && educations && educations.length > 0" class="mt-3 font-italic">
      {{ $t('order-card.no-prof-text') }}
    </p> -->
    
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import {mapActions, mapGetters} from 'vuex'
import {CompanyRoles} from '@/components/mixins'
import {RulesMixin} from '@/components/mixins'
import get from 'lodash/get'
import uniq from 'lodash/uniq'
import find from 'lodash/find'

export default {
  name: 'CompanyPausedPersons',
  mixins: [CompanyRoles, RulesMixin],

  components: {
    ActionButton
  },
  data: () => ({
    educations: [],
    apprentices: [],
    personId: null,
    showMachineBtn: false,
    hasQualTime: false,
    hasTradeCertificates: false
  }),
  watch: {
    personId(newValue, oldValue) {
      this.getApprenticeQTime()
    }
  },
  created() {
    this.init()
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isInstructor', 'isAdministrator', 'isCompanyUser']),
    ...mapGetters('basic', ['hasProfessionOrientations']),
    
    fullName() {
      return find(this.apprentices, ['personId', this.personId]).text
    },
  },

  methods: {
    init() {
      if(!this.$route.params.id)
        this.$router.push("/");

      if (this.$route && this.$route.params && this.$route.params.personId) {
        this.personId = this.$route.params.personId
      }
      this.getApprenticeQTime()
      this.getCompanyApprenticenships()
    },

    getCompanyApprenticenships() {
      const companyId = this.$route.params.id || false
      if (!companyId) return
      let options = {search: '', workplaceId: null, type: 'apprentice'}
      API.listEmployments(this.$route.params.id, options)
        .then(res => {
          res.data.forEach(obj => {
            let basicEducationCertificate = get(obj, 'education.basicEducationCertificate', {})
            if (basicEducationCertificate && Object.keys(basicEducationCertificate).length > 0) {
              uniq(
                this.apprentices.push({
                  text: obj.apprentice.firstName + ' ' + obj.apprentice.lastName,
                  personId: obj.apprentice.id,
                  apprenticenshipId: obj.id
                })
              )
            }
          })
        })
        .catch(error => {
          console.log('Error getting person QT:', error)
        })
    },
    getApprenticeQTime() {
      this.showMachineBtn = false
      let apprenticeId = null
      if (this.personId) {
        apprenticeId = this.personId
      }
      if (!this.isCompanyUser(this.$route.params.id)) {
        apprenticeId = this.currentUser.id
      }

      if (!apprenticeId) return
      API.getQualifyingTime(apprenticeId)
        .then(({data = {}}) => {
          const {educations = []} = data
          this.educations = educations
          this.hasTradeCertificates = data.id === this.personId && data.tradeCertificates.length > 0
          this.educations.forEach(ed => {
            if (this.hasProfessionOrientations(ed.professionId) == true) {
              return (this.showMachineBtn = true)
            }
          })
        })
        .catch(error => {
          console.log('Error getting person QT:', error)
        })
    },
    goTo(type = '') {
      const apprenticeId = this.personId ? this.personId : this.currentUser.id
      
      this.$nextTick(() => {
        this.$router.push({
          name: 'CardCompanyTypes',
          params: {
            companyId: this.$route.params.id,
            personId: apprenticeId,
            type: type,
            apprenticenshipId: find(this.apprentices, ['personId', apprenticeId]).apprenticenshipId,
          }
        })
      })        
    }
  }
}
</script>
<style scoped>

</style>
